import React from "react";

const ReturnTopButton: React.FC = () => {
  const returnTopRef = React.useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (returnTopRef && returnTopRef.current) {
      const scrollTopButton = returnTopRef.current;

      scrollTopButton.style.display = window.scrollY > 200 ? "block" : "none"; // 页面滚动超过200px时显示按钮
    }
  };

  // Scroll to Top
  React.useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div
        className="return-top-button"
        ref={returnTopRef}
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <img src="/jump-to-top.svg" />
      </div>
      <style jsx>{`
        .return-top-button {
          position: fixed;
          right: 24px;
          bottom: 24px;
          width: 40px;
          height: 40px;
          display: none;
          cursor: pointer;
        }
      `}</style>
    </>
  );
};

export default ReturnTopButton;
